import { useCallback, useEffect, useState } from 'react';

export default function useCollections() {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    setError(null);
    return fetch('/.netlify/functions/collections-public')
      .then((r) => {
        if (!r.ok) throw new Error('Failed to load collections');
        return r.json();
      })
      .then((data) => setCollections(data.collections || []))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { collections, loading, error, reload: load };
}
